import { createApp, h } from 'vue'
import App from './App.vue'
import SettingsView from './components/SettingsView.vue'
import './css/main.css'

// Expose App component for fca-events-spaces to mount inside space wrappers
window.FcaEventsApp = App

// ── FC Portal Route Registration ────────────────────────────────────────────

function registerRoutes() {
  window.FluentCommunityUtil.hooks.addFilter(
    'fluent_com_portal_routes',
    'fca_events_routes',
    function (routes) {
      const template = {
        render() {
          return h('div', { class: 'fca-events-root' },
            h('div', { class: 'fcom_single_layout fcom_max_layout feeds fcom_sticky_header' },
              h('div', { class: 'feeds_main' },
                h('div', { class: 'no_bg_layout fhr_content_layout' },
                  h('div', { id: 'fca-events-mount' })
                )
              )
            )
          )
        },

        mounted() {
          createApp(App).mount('#fca-events-mount')

          // Highlight active menu item on navigation
          this._nav = (e) => {
            const link = e.target.closest('a[href]')
            if (!link) return
            const href = link.getAttribute('href')
            if (!href) return

            document.querySelectorAll('.fcom_menu_item').forEach((el) => {
              el.classList.remove('active')
            })
            document.querySelectorAll(`a[href="${href}"]`).forEach((el) => {
              el.closest('.fcom_menu_item')?.classList.add('active')
            })
          }
          document.addEventListener('click', this._nav, true)
        },

        beforeRouteUpdate(to) {
          window.dispatchEvent(
            new CustomEvent('fca-events-route', { detail: { path: to.path, name: to.name } }),
          )
        },

        beforeUnmount() {
          document.removeEventListener('click', this._nav, true)
          const el = document.getElementById('fca-events-mount')
          if (el?.__vue_app__) el.__vue_app__.unmount()
        },
      }

      routes.push({ path: '/events',           name: 'fca_events_list',     component: template, meta: { active: 'fca_events_list' } })
      routes.push({ path: '/events/create',    name: 'fca_events_create',   component: template, meta: { active: 'fca_events_list' } })
      routes.push({ path: '/events/edit/:slug',name: 'fca_events_edit',     component: template, meta: { active: 'fca_events_list' } })
      routes.push({ path: '/event/:eventSlug', name: 'fca_event_single',    component: template, props: true, meta: { active: 'fca_events_list' } })

      return routes
    },
  )
}

// ── Admin Settings Route Component ─────────────────────────────────────────
// Exposed globally so the PHP admin route registration can reference it.
// Follows the same pattern as fca-custom-menus, fca-options, fca-widgets:
//   render() creates a div → mounted() creates a nested Vue 3 app inside it
//   The nested app provides the FC scrollbar wrapper + SettingsView content.

const AdminSettingsApp = {
  setup() {
    const portalBase = ((window.FcaEventsConfig || {}).portalBase || '').replace(/\/+$/, '')
    const handleCancel = () => {
      window.location.href = portalBase + '/admin/settings'
    }
    return { handleCancel }
  },
  render() {
    return h('div', { class: 'fca-events-root no_bg_layout fhr_content_layout fcom_sticky_header', style: 'max-width:none;margin:0;' },
      h('div', { class: 'el-scrollbar' },
        h('div', {
          class: 'el-scrollbar__wrap el-scrollbar__wrap--hidden-default',
          style: 'height:calc(100dvh - var(--fcom-header-height, 0px) - var(--fcom-mobile-menu-height, 0px));overflow-y:auto;',
        },
          h('div', { class: 'el-scrollbar__view' },
            h(SettingsView, { onCancel: this.handleCancel })
          )
        )
      )
    )
  },
}

window.FcaEventsSettingsComponent = {
  render() {
    return h('div', { id: 'fca-events-settings-mount' })
  },
  mounted() {
    const config = window.FcaEventsConfig || {}
    this._settingsApp = createApp(AdminSettingsApp)
    this._settingsApp.provide('config', config)
    this._settingsApp.provide('i18n', config.i18n || {})
    this._settingsApp.mount(this.$el)
  },
  beforeUnmount() {
    if (this._settingsApp) {
      this._settingsApp.unmount()
      this._settingsApp = null
    }
  },
}

// ── Space-embedded mounts (sidebar widget, space page) ─────────────────────
import EventsView      from './components/EventsView.vue'
import EventDetailView from './components/EventDetailView.vue'

window.FcaEventsMountList = function (mountEl) {
  const app = createApp(App)
  app.mount(mountEl)
  return app
}

window.FcaEventsMountDetail = function (mountEl, slug) {
  // Mount the full App — it will parsePath and show the detail view
  // Push the detail path so App.vue picks it up
  const portalBase = ((window.FcaEventsConfig || {}).portalBase || '').replace(/\/+$/, '')
  const spaceCtx = window.FcaSpaceContext
  const spacePrefix = (spaceCtx?.isSpaceContext && spaceCtx.spaceSlug)
    ? '/space/' + spaceCtx.spaceSlug
    : ''
  // Ensure the URL reflects the detail view so parsePath detects it
  const detailPath = spacePrefix
    ? portalBase + spacePrefix + '/events/' + slug
    : portalBase + '/event/' + slug
  history.replaceState({}, '', detailPath)

  const app = createApp(App)
  app.mount(mountEl)
  return app
}

// ── Bootstrap ───────────────────────────────────────────────────────────────

if (window.FluentCommunityUtil?.hooks) {
  registerRoutes()
} else {
  document.addEventListener('fluentCommunityUtilReady', registerRoutes)
}
